import { Node, mergeAttributes } from "@tiptap/core";

/** Composer-only chip after /sign-off — not included in API body. */
export const CollaborateSignoffBadgeExtension = Node.create({
  name: "signoffBadge",

  group: "inline",
  inline: true,
  atom: true,
  selectable: true,

  parseHTML() {
    return [{ tag: 'span[data-signoff-badge="true"]' }];
  },

  renderHTML({ HTMLAttributes }) {
    return [
      "span",
      mergeAttributes(HTMLAttributes, {
        "data-signoff-badge": "true",
        class: "collaborate-signoff-chip collaborate-signoff-chip--pending",
        contenteditable: "false",
      }),
      ["span", { class: "collaborate-signoff-chip__tag" }, "Sign-off"],
      ["span", { class: "collaborate-signoff-chip__hint" }, "· @ assign"],
    ];
  },

  addKeyboardShortcuts() {
    return {
      Backspace: () => {
        const { selection } = this.editor.state;
        if (!selection.empty) {
          return false;
        }
        const { $anchor } = selection;
        const nodeBefore = $anchor.nodeBefore;
        if (nodeBefore?.type.name === this.name) {
          return this.editor
            .chain()
            .focus()
            .deleteRange({ from: $anchor.pos - nodeBefore.nodeSize, to: $anchor.pos })
            .run();
        }
        const parent = $anchor.parent;
        if (parent.type.name === this.name) {
          return this.editor.chain().focus().deleteNode(this.name).run();
        }
        return false;
      },
      Delete: () => {
        const { selection } = this.editor.state;
        if (!selection.empty) {
          return false;
        }
        const nodeAfter = selection.$anchor.nodeAfter;
        if (nodeAfter?.type.name === this.name) {
          return this.editor
            .chain()
            .focus()
            .deleteRange({
              from: selection.$anchor.pos,
              to: selection.$anchor.pos + nodeAfter.nodeSize,
            })
            .run();
        }
        return false;
      },
    };
  },
});
